export const colorsForRenewal = ['#548235', '#a9d18e', '#4473c4', '#ed7c31']
export let renewalsRow = ["Prime", "Premier", "Strategic"]
export const customRow = ["CompletedOnTime", "CompletedDelayed", "Open", "OpenOverdue"]